import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@app/_shared';
import { DownloadInvoiceResponse, TransactionHistoryResponse } from '../../components/transaction-history/transaction-history.interface';

@Injectable({
  providedIn: 'root'
})
export class TransactionHistoryService {

  constructor(
    private http: HttpClient,
    private conf: ConfigurationService
  ) { }

  getTransactionHistory() {
    const url = this.conf.applicationUrls.plansTransactionHistory;
    return this.http.get<TransactionHistoryResponse>(url);
  }

  downloadInvoice(invoiceId: string) {
    const url = this.conf.applicationUrls.downloadInvoice;
    return this.http.get<DownloadInvoiceResponse>(url + invoiceId);
  }
}
